import EntityInput from './EntityInput'

export default EntityInput
